import type { ReactNode } from 'react'

import { UserProfileSection } from '@/components/profile-settings/user-profile-section.organism'

import { useProfileSettings } from './use-profile-settings.hook'

export const GeneralProfileSettingsView: React.FC = (): ReactNode => {
  const settings = useProfileSettings()

  return (
    <div className="general-profile-settings-view space-y-8">
      <UserProfileSection
        firstName={settings.firstName}
        lastName={settings.lastName}
        imageUrl={settings.imageUrl}
        onNameChange={settings.handleNameChange}
        onAvatarChange={settings.handleAvatarChange}
        onAvatarRemove={settings.handleAvatarRemove}
        isLoading={settings.isNameLoading || settings.isAvatarLoading}
      />
    </div>
  )
}

GeneralProfileSettingsView.displayName = 'GeneralProfileSettingsView'
